import { Component } from '@angular/core';

@Component({
  selector: 'gz-admin',
  templateUrl: 'admin.component.html',
})

/**
 * Admin Component is the landing page for system admins.
 * From here they can navigate to other sections.
 */
export class AdminComponent {
}
